import React from "react";
import { Link } from "react-router-dom";
import "../service.css";

export const CancellationPolicy = () => {
  return (
    <div>
      <div className="tj-inner-banner">
        <div className="container">
          <h2>Cancellation Policy</h2>
        </div>
      </div>

      <div className="tj-breadcrumb">
        <div className="container">
          <ul className="breadcrumb-list">
            <li>
              <Link to="/">Home</Link>
            </li>
            <li className="active">Cancellation Policy</li>
          </ul>
        </div>
      </div>
      <div className="container" style={{ paddingTop: "90px" }}>
        <div style={{ padding: "30px", display: "flex" }}></div>

        <h1 className="farex-h1" style={{ textAlign: "center" }}>
          Cancellation Policy
        </h1>

        <div id="section-51737" style={{ clear: "both" }}>
          <div
            className="farex-text basic-page-paragraph-container"
            style={{ overflowY: "auto" }}
          >
            <h2>
              Valid for trips with a scheduled departure date after November
              11th, 2024
            </h2>
            {/* <p>
              Only if you have booked a trip before 30.09.2024 with a scheduled
              departure date after 11.11.2024 and wish to cancel after
              11.11.2024 please contact our customer service through the chat .
            </p> */}
            <p>
              Change of plans? No problem! With Farex, you can cancel your ticket
              up to 15 minutes before departure and get a full or partial refund
              in the form of a coupon.
              <br />
              The table below shows how much you will be refunded. The amount
              depends on how far in advance you cancel your ticket. For example,
              if you cancel your ticket 2 days and 3 hours before departure, you
              will get a 50% refund. The calculation is based on the exact time
              of departure (hour, minute, second).
            </p>
            <table>
              <thead>
                <tr>
                  <th>Time before departure</th>
                  <th>Refund (% of ticket price)</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Less than 2 days</td>
                  <td>25%</td>
                </tr>
                <tr>
                  <td>Between 2 and 6 days</td>
                  <td>50%</td>
                </tr>
                <tr>
                  <td>Between 7 and 14 days</td>
                  <td>75%</td>
                </tr>
                <tr>
                  <td>14 days or more</td>
                  <td>100%</td>
                </tr>
              </tbody>
            </table>
            <p>
              Please note that for extras like seat reservations and additional
              luggage, the refund is 100%. Booking fees and service fees are
              non-refundable.
            </p>
            <p>
              Please find more information in our{" "}
              <Link to={"/term-condition"}>terms &amp; conditions</Link>
              . (Farex)
              <br />
            </p>
            {/* <p className="fineprint">
              <em>For trips within Türkiye a 100% refund policy applies.</em>
            </p> */}
          </div>
        </div>

        {/* <div id="section-43679" style={{ clear: "both" }}>
          <div
            className="farex-text basic-page-paragraph-container"
            style={{ overflowY: "auto" }}
          >
            <h2>
              Valid for trips with a scheduled departure date before November
              11th, 2024
            </h2>
            <p>
              Change of plans? No problem! With Farex, you can cancel your ticket
              up to 15 minutes before departure and get a full or partial refund
              in the form of a coupon.
              <br />
              The table below shows how much you will be refunded. The amount
              depends on how far in advance you cancel your ticket. For example,
              if you cancel your ticket 1 day and 3 hours before departure, you
              will get a 50% refund. The calculation is based on the exact time
              of departure (hour, minute, second).
              <br />
              &nbsp;
            </p>
            <table>
              <thead>
                <tr>
                  <th>Time before departure</th>
                  <th>Refund (% of ticket price)</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Less than 1 day</td>
                  <td>25%</td>
                </tr>
                <tr>
                  <td>Between 1 and 6 days</td>
                  <td>50%</td>
                </tr>
                <tr>
                  <td>Between 7 and 14 days</td>
                  <td>75%</td>
                </tr>
                <tr>
                  <td>14 days or more</td>
                  <td>100%</td>
                </tr>
              </tbody>
            </table>
            <p>
              <br />
              Please note that for extras like seat reservations and additional
              luggage, the refund is 100%. Booking fees and service fees are
              non-refundable.
            </p>
            <p>
              Please find more information in our{" "}
              <Link to={"/term-condition"}>terms &amp; conditions</Link>
              . (Farex)
              <br />
            </p>
            <p className="fineprint">
              <em>For trips within Türkiye a 100% refund policy applies.</em>
            </p>
          </div>
        </div> */}

        <div id="section-43680" style={{ clear: "both" }}>
          <div className="basic-page-paragraph-container">
            <Link
              to={"/booknow"}
              type="button"
              className="farex-btn farex-btn--secondary"
            >
              Manage My Booking
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};
